import { render } from "./DetallePedido.vue?vue&type=template&id=03ba0720&scoped=true"
import script from "./DetallePedido.vue?vue&type=script&lang=js"
export * from "./DetallePedido.vue?vue&type=script&lang=js"

import "./DetallePedido.vue?vue&type=style&index=0&id=03ba0720&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ba0720"]])

export default __exports__